import { Link } from "react-router";
import { t } from "@/shared/i18n";
import { Tarjeta, Vacio } from "@/shared/ui";
import { useTitulo } from "./comun";

export function NoEncontrada() {
  useTitulo(t.noEncontrada.titulo);
  return (
    <Tarjeta>
      <Vacio titulo={t.noEncontrada.titulo} accion={<Link to="/">{t.general.volver}</Link>}>
        {t.noEncontrada.texto}
      </Vacio>
    </Tarjeta>
  );
}
